import { SVGProps } from 'react';

const SvgEarListen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M388.9 3.8C450.6 43 493.6 105.8 508 177.6l3.5 17.7c2.6 13-5.8 25.6-18.8 28.2s-25.6-5.8-28.2-18.8l-3.6-17.7c-11.8-58.9-47.1-110.5-97.8-142.7-11.2-7.1-14.5-22-7.4-33.1s21.9-14.5 33.1-7.4zM240 112c-70.7 0-128 57.3-128 128 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-97.2 78.8-176 176-176s176 78.8 176 176c0 47.5-18.8 90.6-49.4 122.2-4.8 4.9-6.6 9.9-6.6 13.8 0 75.1-60.9 136-136 136-13.3 0-24-10.7-24-24s10.7-24 24-24c48.6 0 88-39.4 88-88 0-19.1 8.9-35.5 20.1-47.1 22.3-23 35.9-54.4 35.9-88.9 0-70.7-57.3-128-128-128zm0 88c-22.1 0-40 17.9-40 40 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6 39.4-88 88-88s88 39.4 88 88c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-22.1-17.9-40-40-40zm-72 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM24 464a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm57-97 64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L47 401c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z" />
  </svg>
);
export default SvgEarListen;
